module.exports = __webpack_public_path__ + "static/media/01_design_agd-tictactu-logo.c4df8498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-tictactu-logo.jpg
// module id = 229
// module chunks = 0